import { elektraAppQueryOptions } from '@connected/elektra-sdk/queries/query-options';
import { Page } from '@connected/ui/features/layouts';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { HeaderNavigation } from '@/components/navigation/header-navigation';
import { ElektraConditionProvider } from '@/providers/condition-provider';

export const Route = createFileRoute(
    '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board',
)({
    component: Layout,
    loader: ({ context, params }) => {
        context.queryClient.ensureQueryData(elektraAppQueryOptions.project.inspection.distributionBoard.distributionBoardOptions({ electricalProjectDistributionBoardId: params.distributionboardId }));
        context.queryClient.ensureQueryData(elektraAppQueryOptions.project.inspection.information.inspectionsEditOptions({ electricalProjectVersionId: params.projectVersionId }));
    },
});

function Layout() {
    const params = Route.useParams();

    const { data } = useQuery(elektraAppQueryOptions.project.inspection.distributionBoard.distributionBoardOptions({ electricalProjectDistributionBoardId: params.distributionboardId }));
    const { data: inspectionData } = useQuery(elektraAppQueryOptions.project.inspection.information.inspectionsEditOptions({ electricalProjectVersionId: params.projectVersionId }));

    const distributionBoardName = data?.DistributionBoard?.Identifier;
    const enableExtendedRiso = inspectionData?.Inspection?.EnableExtendedRisoOnDistributionBoardDevices ?? false;

    // Use the ElektraConditionProvider with enableExtendedRiso override
    // This makes the RISO tab visible when the inspection has it enabled
    return (
        <ElektraConditionProvider enableExtendedRiso={enableExtendedRiso}>
            <DistributionBoardLayout distributionBoardName={distributionBoardName} />
        </ElektraConditionProvider>
    );
}

function DistributionBoardLayout({ distributionBoardName }: { distributionBoardName: string | null | undefined }) {
    const params = Route.useParams();

    return (
        <Page>
            <Page.Header>
                <Page.Header.Bar>
                    <Page.Header.Back
                        to="/projects/$projectVersionId/re-inspections/distributionboards"
                        params={{ projectVersionId: params.projectVersionId }}
                    />
                    <Page.Header.Title>
                        {distributionBoardName || 'Naamloze verdeelinrichting'}
                    </Page.Header.Title>
                </Page.Header.Bar>
                <HeaderNavigation />
            </Page.Header>
            <Page.Outlet className="gap-4" />
        </Page>
    );
}
